import {
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import GModal from "../../../../components/Modal";
import { setDailyTasksToDelete } from "../../../../config/redux/slices/schedulerSlice";
import {
  selectDailyTasksData,
  selectDailyTasksToDelete,
} from "../../../../config/redux/slices/schedulerSlice/selectors";
import { StyledAvatar } from "../../../../pages/Sidebar/styles";
import { StyledEmojiRow, StyledHeaderText, StyledTasksList } from "./styles";

const TaskDeletionModal = ({ visible, setVisible }) => {
  const dispatch = useDispatch();
  const prevTasksToDelete = useSelector(selectDailyTasksToDelete);
  const [tasksToDelete, setTasksToDelete] = React.useState(prevTasksToDelete);
  const tasksData = useSelector(selectDailyTasksData);
  const tasksList = tasksData.data || [];

  const cancelModal = () => {
    setVisible(false);
    setTasksToDelete(prevTasksToDelete);
  };

  const handleSubmit = () => {
    dispatch(setDailyTasksToDelete(tasksToDelete));
    toast.info(
      tasksToDelete.length
        ? "Added tasks to delete. Sync to upload"
        : "Cleared tasks to delete"
    );
    setVisible(false);
  };

  const handleToggle = (taskId) => () => {
    const currentIndex = tasksToDelete.indexOf(taskId);
    const newChecked = [...tasksToDelete];

    if (currentIndex === -1) {
      newChecked.push(taskId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setTasksToDelete(newChecked);
  };

  return (
    <GModal
      Modal
      isOpen={visible}
      onClose={cancelModal}
      title="Daily Task - Deletion"
      width="540px"
    >
      <StyledHeaderText>
        <Typography variant="body2" color="textSecondary">
          Select tasks to delete
        </Typography>
      </StyledHeaderText>

      <StyledTasksList>
        <List dense>
          {tasksList.map((task) => {
            return (
              <ListItem
                key={task._id}
                onClick={handleToggle(task._id)}
                secondaryAction={
                  <Checkbox
                    sx={{ marginRight: 0.5 }}
                    edge="end"
                    color="error"
                    onChange={handleToggle(task._id)}
                    checked={tasksToDelete.includes(task._id)}
                  />
                }
                disablePadding
              >
                <ListItemButton>
                  <ListItemAvatar>
                    <StyledAvatar>
                      <Typography variant="h6" fontWeight="bold">
                        {task.emoji}
                      </Typography>
                    </StyledAvatar>
                  </ListItemAvatar>
                  <ListItemText primary={task.title} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </StyledTasksList>

      <StyledEmojiRow>
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          onClick={cancelModal}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="large"
          color="error"
          endIcon={<AiOutlineDelete />}
          onClick={handleSubmit}
          disabled={!tasksToDelete.length}
        >
          Save for Deletion
        </Button>
      </StyledEmojiRow>
    </GModal>
  );
};

export default TaskDeletionModal;
